import React from 'react';
import { Route } from 'react-router-dom';
import * as ROUTES from '../constants/routes';
import SampleOrders from '../screens/SamplingsScreen/sampleOrders';

const SamplingRoutes = () => {
  return (
    <>
      <Route
        path={ROUTES.SAMPLE_ORDERS}
        exact
        component={() => <SampleOrders />}
      />
    </>
  );
};

export default SamplingRoutes;
